import { Button } from '@blueprintjs/core'
// TODO - Documentar
import { useState } from 'react'
import Modal from '../../templates/popups/Modal'
import * as con from "../../GlobalConstants"
import { translateTransactions } from '../../utils/translateFunctions'
import { RefModelParameterHook } from '../hooks/ModelParameterHooks'
import TransactionsDeleteDialog from './TransactionsDeleteDialog'
import { RefTransactionsHook } from '../hooks/TransactionsHooks'
import { deleteAllTransactions, replaceTransactions } from '../../store/slices/transactionsSlice'
import defaultAccounts from "../../config/default_accounts.json"
import { useDispatch } from 'react-redux'


function TransactionsDelete() {

    const dispatch = useDispatch()
    // Selected Transactions
    const selectedTransactions = RefTransactionsHook(con.SELECTED_TRANSACTIONS)

    // Client Type
    const clientType = RefModelParameterHook(con.CLIENT_TYPE)

    // Delete all dialog
    const [showDeleteAllDialog, setShowDeleteAllDialog] = useState(() => false)
    const [showDeleteCurrentDialog, setShowDeleteCurrentDialog] = useState(() => false)

    const resetAccounts = () => {
        dispatch(replaceTransactions({
            transactionType: con.ACCOUNTS,
            values: defaultAccounts
        }))
    }

    const deleteAllSelectedTransactions = () => {
        if (selectedTransactions === con.ACCOUNTS)
            resetAccounts()
        else
            dispatch(deleteAllTransactions(selectedTransactions))

        setShowDeleteCurrentDialog(false)
    }

    const deleteAllTransactionsHandler = () => {
        dispatch(deleteAllTransactions(con.EXPOSURES))
        dispatch(deleteAllTransactions(con.COVERAGES_FWD))
        dispatch(deleteAllTransactions(con.COVERAGES_OPTION))
        dispatch(deleteAllTransactions(con.COVERAGES_SPOT))
        resetAccounts()
        setShowDeleteAllDialog(false)
    }


  return (
    <div>

        <Modal show={showDeleteAllDialog} doAccept={null} showCancel={false} doCancel={(e) => setShowDeleteAllDialog(false)}>
              <TransactionsDeleteDialog 
                title="¿Desea Eliminar Todos los Registros?"
                deleteAction={() => deleteAllTransactionsHandler()}
                cancelAction={() => setShowDeleteAllDialog(false)} />              
        </Modal>
        <Modal show={showDeleteCurrentDialog} doAccept={null} showCancel={false}  doCancel={(e) => setShowDeleteCurrentDialog(false)}>
              <TransactionsDeleteDialog 
                title={`¿Desea ${selectedTransactions !== con.ACCOUNTS ? "Eliminar" : "Vaciar"} Todas las ${translateTransactions(selectedTransactions, clientType)}?`}
                deleteAction={() => deleteAllSelectedTransactions()}
                cancelAction={() => setShowDeleteCurrentDialog(false)} />  
        </Modal>        

        <div className="columnParameterBox">  
                  <div style={{marginBottom : '1vh'}}>
                    <Button text={`${selectedTransactions !== con.ACCOUNTS ? "Eliminar" : "Vaciar"} ${translateTransactions(selectedTransactions, clientType)}`}  icon="cross" onClick={(e) => setShowDeleteCurrentDialog(true)}/>
                  </div>
                  <div> 
                    <Button text={`Eliminar Todo`}  icon="cross" onClick={(e) => setShowDeleteAllDialog(true)} />
                  </div>
              </div>

    </div>
  )
}

export default TransactionsDelete